export const HR_PAYROLL_ENTITLEMENT = "hr_payroll";
export const WORKFORCE_ANALYTICS_ENTITLEMENT = "workforce_analytics";
export const HR_PAYROLL_AI_ENTITLEMENT = "hr_payroll_ai";
export const ASSISTANT_ENTITLEMENT = "assistant";

const HR_PAYROLL_ROUTE_ROOTS = [
  "/app/hr",
  "/app/payroll",
  "/app/organisation",
  "/app/teachers",
  "/app/leave",
  "/app/me",
  "/app/grievances",
];

const pathAtOrBelow = (pathname, root) => (
  pathname === root || pathname.startsWith(`${root}/`)
);

const normalizedLocation = (value) => {
  const rawPath = typeof value === "string" ? value : value?.pathname;
  const [pathAndQuery] = (rawPath || "/").split("#");
  const [pathOnly, inlineQuery = ""] = pathAndQuery.split("?");
  const pathname = pathOnly.replace(/\/$/, "") || "/";
  const suppliedSearch = typeof value === "object" ? value?.search || "" : "";
  return {
    pathname,
    search: new URLSearchParams(String(suppliedSearch || inlineQuery).replace(/^\?/, "")),
  };
};

/**
 * Returns every platform-controlled entitlement required before an HR & Payroll route may mount.
 * The order is intentional: the product gate precedes narrower capabilities in restricted-state
 * messaging and in tests.
 */
export function requiredHrPayrollEntitlements(value) {
  const { pathname, search } = normalizedLocation(value);
  const isHrProductRoute = HR_PAYROLL_ROUTE_ROOTS.some(
    (root) => pathAtOrBelow(pathname, root),
  );
  const isHrPayrollSettings = pathname === "/app/settings" && search.get("tab") === "hr-payroll";
  const isGovernedReportsTab = pathname === "/app/reports"
    && ["schedules", "exports"].includes(search.get("tab"));
  if (!isHrProductRoute && !isHrPayrollSettings && !isGovernedReportsTab) return [];

  const required = [HR_PAYROLL_ENTITLEMENT];
  if (
    pathAtOrBelow(pathname, "/app/hr/analytics")
    || isHrPayrollSettings
    || isGovernedReportsTab
  ) {
    required.push(WORKFORCE_ANALYTICS_ENTITLEMENT);
  }
  if (pathAtOrBelow(pathname, "/app/hr/copilot")) {
    // Keep the existing assistant-plan boundary as well as the dedicated, readiness-controlled
    // HR intelligence switch. The backend dependency resolver enforces the same relationship.
    required.push(ASSISTANT_ENTITLEMENT, HR_PAYROLL_AI_ENTITLEMENT);
  }
  return required;
}

/**
 * Readiness-gated products fail closed. An old or malformed session without an explicit feature
 * list must never reveal a module that a platform administrator has not enabled.
 */
export function hasRequiredSessionFeatures(user, requiredFeatures) {
  if (!requiredFeatures?.length) return true;
  if (!Array.isArray(user?.features)) return false;
  return requiredFeatures.every((feature) => user.features.includes(feature));
}
